import { render } from "./playerSidebar.vue?vue&type=template&id=25d617a1&scoped=true"
import script from "./playerSidebar.vue?vue&type=script&lang=js"
export * from "./playerSidebar.vue?vue&type=script&lang=js"

import "./playerSidebar.vue?vue&type=style&index=0&id=25d617a1&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d617a1"]])

export default __exports__